import { apiSlice } from './baseApi';
import { DEFAULT_PAGE_LIMIT } from '@constants/appDefaults';

export const investmentApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getInvestments: builder.query({
      query: ({ companyId, tableFilterOutcomingData, page, limit = DEFAULT_PAGE_LIMIT }) => ({
        url: '/investment/get-all-investments',
        method: 'POST',
        body: {
          company_id: companyId,
          tableFilterOutcomingData,
          page,
          limit,
        },
      }),
      transformResponse: (response) => ({
        investments: response?.investments ?? [],
        totalPages: response?.totalPages ?? 1,
        allTimeSum: response?.allTimeSum ?? 0,
      }),
      providesTags: ['Investments'],
    }),
    deleteInvestment: builder.mutation({
      query: (body) => ({
        url: '/investment/delete-investment',
        method: 'POST',
        body,
      }),
      invalidatesTags: ['Investments', 'AccountCodeAmounts'],
    }),
    addInvestment: builder.mutation({
      query: (body) => ({
        url: '/investment/add-new-investment',
        method: 'POST',
        body,
      }),
      invalidatesTags: ['Investments', 'AccountCodeAmounts'],
    }),
    editInvestment: builder.mutation({
      query: (body) => ({
        url: '/investment/edit-investment',
        method: 'POST',
        body,
      }),
      invalidatesTags: ['Investments', 'AccountCodeAmounts'],
    }),
  }),
});
